import { IAPIResponse } from "../../ts/api";
import { IFundsState } from "../../ts/redux";

export function fundsFormatter(payload: IAPIResponse): Promise<IFundsState> {
    const fundsData = payload.funds;
    return Promise.resolve(fundsData);
}